import { HTTP_HEADERS } from 'consts';
import { apiClient } from 'shared/api/lib';

import type { GetSsoRequestType } from '../types';

export const getSso = async ({
  headers,
  pathParams: { ssoDriver },
  queryParams,
}: GetSsoRequestType) => {
  const query = queryParams?.email
    ? `?${new URLSearchParams({ email: queryParams.email }).toString()}`
    : '';
  const url = `/api/v2/sso/${ssoDriver}${query}`;

  const data = await apiClient.get<{ data: '' }>(url, {
    headers,
  });

  return data.headers[HTTP_HEADERS.xRedirectTo];
};
